import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import notify from 'devextreme/ui/notify';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { ServicesService } from '../services/services.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-registro',
  templateUrl: './registro.component.html',
  styleUrls: ['./registro.component.css']
})
export class RegistroComponent implements OnInit {

  activeTab: 'social' | 'email' = 'social';
  showPassword = false;

  setTab(tab: 'social' | 'email') {
    this.activeTab = tab;

    // Cuando cambias de tab, ajustas validaciones
    if (tab === 'email') {
      this.registerForm.get('fullName')?.setValidators([Validators.required]);
      this.registerForm.get('email')?.setValidators([Validators.required, Validators.email]);
      this.registerForm.get('password')?.setValidators([Validators.required, Validators.minLength(6)]);
    } else {
      // Si es redes sociales, no se requieren los campos de email
      this.registerForm.get('fullName')?.clearValidators();
      this.registerForm.get('email')?.clearValidators();
      this.registerForm.get('password')?.clearValidators();
    }

    this.registerForm.get('fullName')?.updateValueAndValidity();
    this.registerForm.get('email')?.updateValueAndValidity();
    this.registerForm.get('password')?.updateValueAndValidity();
  }

  proyectos: any;

  // 👇 Formulario reactivo
  registerForm: FormGroup;

  constructor(private authService: AuthService, private fb: FormBuilder, private serviceService: ServicesService, private router: Router, private route: ActivatedRoute) {
    this.registerForm = this.fb.group({
      companyName: ['', Validators.required],
      fullName: [''],
      email: [''],
      password: ['']
    });
  }

  ngOnInit(): void {
    this.recuperarParams();
  }

  recuperarParams() {
    this.route.queryParams.subscribe(params => {

      if (params['registroToken']) {
        this.registroEmailUsuario(params)
      }
      console.log(params);
    });
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }



  // 👇 Aquí capturas los datos al enviar
  onSubmit() {
    if (this.activeTab === 'email' && this.registerForm.invalid) {
      this.registerForm.markAllAsTouched();
      return;
    }

    const formData = {
      nombre: this.registerForm.value.companyName,
      usuario: {
        nombre: this.registerForm.value.fullName,
        email: this.registerForm.value.email,
        password: this.registerForm.value.password
      }
    };

    console.log('📦 Datos capturados:', formData);

    this.authService.registroFormulario(formData).subscribe({
      next: (res1: any) => {
        console.log(res1);

        console.log((res1))
        window.sessionStorage.setItem('access_token', res1.access_token);
        window.sessionStorage.setItem('username', res1.userName);
        this.proyectos = JSON.parse(res1.proyectos);
        this.authService.setIdUsuario(res1.idUsuario);
        this.authService.getIdClient(res1.access_token, res1.idUsuario).subscribe({
          next: res => {
            console.log((res))
            let pendienteLegalizar = res.DatosCliente[0]?.PendienteLegalizacion;
            window.sessionStorage.setItem('PendienteLegalizacion', pendienteLegalizar === null || pendienteLegalizar === false ? 'false' : 'true');
            window.sessionStorage.setItem('dominio', res.DatosCliente[0]?.Dominio);
            window.sessionStorage.setItem('anticipoTotal', res.DatosCliente[0]?.AnticipoTotal);
            localStorage.setItem('img', "data:image/png;base64," + res.DatosCliente[0]?.Imagen);
            // window.sessionStorage.setItem('idCliente', res.DatosCliente[0].IdCliente);
            this.authService.setIdCliente(res.DatosCliente[0]?.IdCliente);
            window.sessionStorage.setItem('idErp', res.DatosCliente[0]?.IdERP);
            window.sessionStorage.setItem('centroCosto', res.DatosCliente[0]?.CentroCosto);
            window.sessionStorage.setItem('CentroCostoAutomatico', res.DatosCliente[0]?.CentroCostoAutomatico);
            window.sessionStorage.setItem('Topes', res.DatosCliente[0]?.Topes);
            window.sessionStorage.setItem('Tercero', res.DatosCliente[0]?.Tercero);
            window.sessionStorage.setItem('Iva', res.DatosCliente[0]?.Iva);
            window.sessionStorage.setItem('Campos', JSON.stringify(res.DatosCliente[0]?.Campos))
            window.sessionStorage.setItem('IdCliente', JSON.stringify(res.DatosCliente[0]?.IdCliente))
            window.sessionStorage.setItem('SumaColumnas', JSON.stringify(res.DatosCliente[0]?.SumaColumnas))
            window.sessionStorage.setItem('RequiereAprobadorSeleccionado', JSON.stringify(res.DatosCliente[0]?.RequiereAprobadorSeleccionado))
            window.sessionStorage.setItem('IdTipoSeleccionCentroCosto', JSON.stringify(res.DatosCliente[0]?.IdTipoSeleccionCentroCosto))
            this.obtenerDatosUsuario(res1.idUsuario);
            console.log(res.DatosCliente[0]?.IdCliente)
            res.DatosCliente[0]?.IdCliente === "33807A31-02DB-4118-B6A5-E1519FDCB862"
              ? window.sessionStorage.setItem('esMapei', 'true')
              : window.sessionStorage.setItem('esMapei', 'false');
            res.DatosCliente[0]?.IdCliente === "0F78E40A-63D9-4731-8912-147A619BCA31"
              ? window.sessionStorage.setItem('esLiga', 'true')
              : window.sessionStorage.setItem('esLiga', 'false');

          },
          error: err => {
            console.log(err)
          },
          complete: () => {


            // .then(()=>{window.location.reload()});
          }
        })

      },
      error: (err) => {
        console.log(err);
        notify('Ocurrió un error', 'error', 5000);
        // if (err.status == 400) { notify('Error guardando las facturas', 'info', 9000); } else { notify('Ocurrió un error', 'error', 5000); }
      }
    })
  }



  registroEmailUsuario(data: any) {

    const formData = {
      socialCode: data.socialCode,
    };


    this.authService.registroEmailUsuario(data.idCliente, formData, data.registroToken).subscribe({
      next: (res1: any) => {
        console.log(res1);

        console.log((res1))
        window.sessionStorage.setItem('access_token', res1.access_token);
        window.sessionStorage.setItem('username', res1.userName);
        this.proyectos = JSON.parse(res1.proyectos);
        this.authService.setIdUsuario(res1.idUsuario);
        this.authService.getIdClient(res1.access_token, res1.idUsuario).subscribe({
          next: res => {
            console.log((res))
            let pendienteLegalizar = res.DatosCliente[0]?.PendienteLegalizacion;
            window.sessionStorage.setItem('PendienteLegalizacion', pendienteLegalizar === null || pendienteLegalizar === false ? 'false' : 'true');
            window.sessionStorage.setItem('dominio', res.DatosCliente[0]?.Dominio);
            window.sessionStorage.setItem('anticipoTotal', res.DatosCliente[0]?.AnticipoTotal);
            localStorage.setItem('img', "data:image/png;base64," + res.DatosCliente[0]?.Imagen);
            // window.sessionStorage.setItem('idCliente', res.DatosCliente[0].IdCliente);
            this.authService.setIdCliente(res.DatosCliente[0]?.IdCliente);
            window.sessionStorage.setItem('idErp', res.DatosCliente[0]?.IdERP);
            window.sessionStorage.setItem('centroCosto', res.DatosCliente[0]?.CentroCosto);
            window.sessionStorage.setItem('CentroCostoAutomatico', res.DatosCliente[0]?.CentroCostoAutomatico);
            window.sessionStorage.setItem('Topes', res.DatosCliente[0]?.Topes);
            window.sessionStorage.setItem('Tercero', res.DatosCliente[0]?.Tercero);
            window.sessionStorage.setItem('Iva', res.DatosCliente[0]?.Iva);
            window.sessionStorage.setItem('Campos', JSON.stringify(res.DatosCliente[0]?.Campos))
            window.sessionStorage.setItem('IdCliente', JSON.stringify(res.DatosCliente[0]?.IdCliente))
            window.sessionStorage.setItem('SumaColumnas', JSON.stringify(res.DatosCliente[0]?.SumaColumnas))
            window.sessionStorage.setItem('RequiereAprobadorSeleccionado', JSON.stringify(res.DatosCliente[0]?.RequiereAprobadorSeleccionado))
            window.sessionStorage.setItem('IdTipoSeleccionCentroCosto', JSON.stringify(res.DatosCliente[0]?.IdTipoSeleccionCentroCosto))
            this.obtenerDatosUsuario(res1.idUsuario);
            console.log(res.DatosCliente[0]?.IdCliente)
            res.DatosCliente[0]?.IdCliente === "33807A31-02DB-4118-B6A5-E1519FDCB862"
              ? window.sessionStorage.setItem('esMapei', 'true')
              : window.sessionStorage.setItem('esMapei', 'false');
            res.DatosCliente[0]?.IdCliente === "0F78E40A-63D9-4731-8912-147A619BCA31"
              ? window.sessionStorage.setItem('esLiga', 'true')
              : window.sessionStorage.setItem('esLiga', 'false');

          },
          error: err => {
            console.log(err)
          },
          complete: () => {


            // .then(()=>{window.location.reload()});
          }
        })

      },
      error: (err) => {
        console.log(err);
        if (err.status !== 500) { notify(err.error.message, 'info', 9000); }
        else { notify('Ocurrió un error', 'error', 5000); }
      }
    })
  }

  // 👇 Métodos para redes sociales
  registerWithProveedorEmail(proveedor: string) {

    const companyNameCtrl = this.registerForm.get('companyName');

    // Validar solo companyName
    if (companyNameCtrl?.invalid) {
      companyNameCtrl.markAsTouched();
      return;
    }

    const formData = {
      nombre: this.registerForm.value.companyName,
    };

    console.log('📦 Datos capturados:', formData);

    this.authService.registroFormulario(formData).subscribe({
      next: (res: any) => {
        console.log(res);
        res.proveedor = proveedor; // Agregar el proveedor al objeto res
        this.obtenerUrlRegistro(res);
      },
      error: (err) => {
        console.log(err);
        notify('Ocurrió un error', 'error', 5000);
        // if (err.status == 400) { notify('Error guardando las facturas', 'info', 9000); } else { notify('Ocurrió un error', 'error', 5000); }
      }
    })
  }


  obtenerUrlRegistro(data: any) {
    console.log(data);


    this.authService.obtenerUrlRegistro(data).subscribe({
      next: (res: any) => {
        console.log(res);
        window.location.href = res.url; // Redirige al usuario a la URL proporcionada por el backend
      },
      error: (err) => {
        console.log(err);
        notify('Ocurrió un error', 'error', 5000);
      }
    })
  }


  iniciarSesionEmail() {

    this.authService.iniciarSesionEmail().subscribe({
      next: (res: any) => {
        console.log(res);

      },
      error: (err) => {
        console.log(err);
        notify('Ocurrió un error', 'error', 5000);
      }
    })
  }




  async obtenerDatosUsuario(idUsuario: any) {
    console.log(idUsuario);
    try {
      const res: any = await firstValueFrom(this.serviceService.GetDatosUsuarioId(idUsuario));
      console.log(res)
      window.sessionStorage.setItem('ubicacion', JSON.stringify(res.Usuario[0]?.Ubicacion));
      window.sessionStorage.setItem('idUbicacion', JSON.stringify(res.Usuario[0]?.IdUbicacion));
      window.sessionStorage.setItem('monedaUsuario', res.Usuario[0]?.Moneda);
      window.sessionStorage.setItem('IdCargo', res.Usuario[0]?.IdCargo);
      window.sessionStorage.setItem('Cargo', res.Usuario[0]?.Cargo);
      console.log(this.proyectos);
      if (this.proyectos[0]?.IdProyecto == 2) {
        this.router.navigate(["pre-conciliacion"])
      } else {
        this.router.navigate(["home"])
      }

    } catch (error) {
      console.error('Error obteniendo datos del usuario:', error);
      throw error; // Puedes decidir qué hacer con el error, ya sea manejarlo o propagarlo.
    }
  }

}
